import { apiClient } from './api';
import type { StockRating, StockRatingsResponse, RatingAction } from '../types/ratings';

export interface FetchRatingsParams {
  page?: number;
  perPage?: number;
  action?: RatingAction;
  search?: string;
}

interface PortalMeta {
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
}

export const ratingsService = {
  async fetchRatings(params: FetchRatingsParams = {}): Promise<StockRatingsResponse> {
    const { page = 1, perPage = 20, action, search } = params;
    const queryParams = new URLSearchParams({
      page: String(page),
      per_page: String(perPage),
    });
    if (action) queryParams.set('action', action);
    if (search) queryParams.set('search', search);

    const result = await apiClient.get<{ data: StockRating[]; meta: PortalMeta }>(
      `/api/market-data/stock-ratings/?${queryParams}`
    );

    return {
      results: result.data ?? [],
      count: result.meta.total_count,
      page: result.meta.page,
      per_page: result.meta.page_size,
      total_pages: result.meta.total_pages,
    };
  },
};
